module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-4"
  }, [_c('div', {
    staticClass: "my-componant no-border"
  }, [_c('h1', [_vm._v("Parent")]), _vm._v(" "), _c('p', [_vm._v("Message ("), _c('strong', [_vm._v("child1")]), _vm._v(") : " + _vm._s(_vm.msgChild1))]), _vm._v(" "), _c('p', [_vm._v("Message ("), _c('strong', [_vm._v("child2")]), _vm._v(") : " + _vm._s(_vm.msgChild2))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('CommunicateChild1', {
    staticClass: "my-componant"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('CommunicateChild2', {
    staticClass: "my-componant lastChild"
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ba94e90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communicate-main.vue
// module id = 101
// module chunks = 0